export default __webpack_public_path__ + "static/gs-1-upload-b36efa64b80f2642a1ed99f1b98fab08.jpg";